import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from 'components/UI/V3/Timeline/Group/TimelineGroup.module.scss';
import { Moment } from 'moment-timezone';
import React from 'react';

interface TimelineGroupProps {
    label: string | Moment;
    collapsible?: boolean;
    children: React.ReactNode;
}

export const TimelineGroup: React.FC<TimelineGroupProps> = ({ label, collapsible = false, children }) => {
    const [isCollapsed, setIsCollapsed] = React.useState(false);

    const labelText = React.useMemo(() => {
        if (typeof label === 'string') {
            return label;
        }

        return label.format('dddd, DD MMM YYYY');
    }, [label]);

    const collapseHandler = React.useCallback(() => {
        if (!collapsible) {
            return;
        }

        setIsCollapsed(!isCollapsed);
    }, [collapsible, isCollapsed]);

    return (
        <>
            <div
                className={styles.header}
                data-collapsible={collapsible}
                onClick={collapseHandler}
            >
                <p className={styles.label}>{labelText}</p>

                {collapsible && (
                    <FontAwesomeIcon
                        className={styles.icon}
                        icon={isCollapsed ? faAngleDown : faAngleUp}
                    />
                )}
            </div>

            {!isCollapsed && children}
        </>
    );
};
